module.exports = __webpack_public_path__ + "img/1fertig.68f36676.jpg";